import React from 'react'
import HomeContent from '../components/organisms/home-content/home-content'
import AppSEO from '../components/atoms/app-seo/app-seo'
import { initTageo } from '../utils/taggeo'
import CrazyEgg from '../utils/CrazyEgg'

initTageo()

function IndexPage() {
  return (
    <>
      <CrazyEgg />
      <AppSEO />
      <HomeContent />
    </>
  )
}

export default IndexPage
